import { Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import LenisScroll from "@/components/LenisScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import Admin from "@/pages/Admin";
import FranchisePage from "@/pages/FranchisePage";
import { Toaster } from "@/components/ui/sonner";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    console.error("App error:", error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-espresso text-cream">
          <p className="font-display text-2xl">Something went wrong. Please refresh.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollTop = () => {
  const { pathname } = useLocation();
  if (pathname !== "/" && !window.__initialLoaded) {
    window.__initialLoaded = true;
  }
  return null;
};

const Grain = () => (
  <div
    aria-hidden="true"
    className="pointer-events-none fixed inset-0 z-[70] opacity-[0.05] mix-blend-overlay"
    style={{
      backgroundImage:
        "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
    }}
  />
);

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <LenisScroll />
        <ScrollTop />
        <div className="min-h-screen bg-espresso">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/franchise" element={<FranchisePage />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
          <WhatsAppFloat />
          <Grain />
          <Toaster position="bottom-center" theme="dark" />
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
